import React from 'react';
import { Box } from '@mui/material';
import { Journals } from '../../../types/Journals.types';
import { JournalsTableDesktop } from './JournalsTableDesktop';
import { JournalsTableMobile } from './JournalsTableMobile';
import { EmptyState } from './EmptyState';
import { NoResultsBanner } from './NoResultsBanner';
import { InternalSearchFilter, InternalSearchFilterKeys } from '../types';

interface JournalsTableProps {
  journals: Journals[] | undefined;
  order: 'asc' | 'desc';
  orderBy: keyof Journals;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Journals
  ) => void;
  filters: InternalSearchFilter;
  selectedFilters: InternalSearchFilter;
  hasFiltersApplied?: boolean;
  lastSearchTerm?: string;
  isLoading?: boolean;
  onToggleFilter: (type: InternalSearchFilterKeys, value: string) => void;
}

export const JournalsTable = ({
  journals,
  order,
  orderBy,
  onRequestSort,
  filters,
  selectedFilters,
  hasFiltersApplied = false,
  lastSearchTerm = '',
  isLoading = false,
  onToggleFilter,
}: JournalsTableProps) => {
  const hasSearchOrFilters = lastSearchTerm.trim() !== '' || hasFiltersApplied;

  const showEmptyState =
    !isLoading && (!journals || journals.length === 0) && !hasSearchOrFilters;

  const showNoResultsBanner =
    !isLoading &&
    Array.isArray(journals) &&
    journals.length === 0 &&
    hasSearchOrFilters;

  return (
    <>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <JournalsTableDesktop
          journals={journals}
          order={order}
          orderBy={orderBy}
          onRequestSort={onRequestSort}
          filters={filters}
          selectedFilters={selectedFilters}
          onToggleFilter={onToggleFilter}
        />
      </Box>
      <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
        <JournalsTableMobile
          journals={journals}
          filters={filters}
          selectedFilters={selectedFilters}
          hasFiltersApplied={hasFiltersApplied}
          onToggleFilter={onToggleFilter}
        />
      </Box>
      {showEmptyState && <EmptyState />}
      {showNoResultsBanner && <NoResultsBanner />}
    </>
  );
};
